export { default as TemplateEditorHome } from './Home';